export const pagesContext = 'campaigns-pages';
